export enum ResourceType {
    GROUPS                       = 'groups',
    GROUP_ROLE_PERMISSIONS       = 'groupRolePermissions',
    SAFETY_MODELS                = 'safetyModels',
    EVENT_SEQUENCE_HISTORY       = 'eventSequenceHistory',
    EVENT_SEQUENCES              = 'eventSequences',
    EVENT_SEQUENCE_TREES         = 'eventSequenceTrees',
    EVENT_SEQUENCE_HISTORY_TREES = 'eventSequenceHistoryTrees',
    EVENT_SEQUENCE_SENSITIVIY_ANALYSIS = 'eventSequenceSensitivityAnalysis',
    EVENT_SEQUENCE_UNCERTAINTY_ANALYSIS = 'eventSequenceUncertaintyAnalysis',
    FOUNDRY_EVENTS               = 'foundryEvents',
    INTEGRATED_RISK_PICTURES     = 'integratedRiskPictures',
    IRP_WORKBOOK                = 'irpWorkbook',
    NEW_OCCURRENCE_REPORTS      = 'newOccurrenceReports',
    OCCURRENCE_REPORT_DESCRIPTORS = 'occurrenceReportDescriptors',
    OCCURRENCE_REPORTS           = 'occurrenceReports',
    OCCURRENCE_TYPES             = 'occurrenceTypes',
    PERFORMANCE_SHAPING_FACTORS = 'performanceShapingFactors',
    TRAFFIC_MODELS               = 'trafficModels',
    OPERATIONAL_CHANGES          = 'operationalChanges',
    RISK_FORECASTS               = 'riskForecasts',
    SAFETY_RECOMMENDATIONS       = 'safetyRecommendations',
    SAFETY_RECOMMENDATION        = 'safetyRecommendation',
    WORKSHOPS                    = 'workshops',
    USERS                         = 'users',
    SERVICE_USER_ACCOUNTS         = 'serviceUsers',
    COMPONENT                     = 'components',
    COMPONENT_TREE                = 'componentTree',
    COMPONENT_MAPPING             = 'componentMapping',
    COMPONENT_CATALOGUE           = 'componentCatalogue',
    COMPONENT_HISTORY             = 'componentHistory',
    COMPONENT_HISTORY_TREE        = 'componentHistoryTree',
    UNKNOWN                       = 'unknown',
}
